import { type FC, useEffect } from "react";
import dateTimeUtils from "../../../../../../utils/dateTimeUtils";
import { type IWizardStep } from "../../../../../../interfaces/IWizardStepsManager";
import { getPeopleSection } from "utils/sendConfirmationUtils";

import styles from "./confirmation.module.scss";

export interface ConfirmationProps extends IWizardStep {
  schedule: Date;
  scheduleTimeZone: string | null;
  communicationTitle: string;
  selectedUserIds: number[];
  selectedGroupIds: number[];
  selectedTemplateIds: number[];
  promptText: React.ReactElement;
  onConfirm: () => void;
}

export const Confirmation: FC<ConfirmationProps> = (props) => {
  const {
    schedule,
    scheduleTimeZone,
    communicationTitle,
    selectedUserIds,
    selectedGroupIds,
    selectedTemplateIds,
    promptText,
    acceptHandlers,
    onConfirm,
  } = props;

  useEffect(() => {
    acceptHandlers?.({
      onFinish: onConfirm,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDateTimeSection = () => {
    return (
      <li>
        On{" "}
        <b>
          {scheduleTimeZone
            ? dateTimeUtils.customFormatDateWithTimeZone(schedule, scheduleTimeZone, "LL")
            : dateTimeUtils.customFormatDate(schedule, "LL")}{" "}
        </b>
        at <b>{dateTimeUtils.dateToTimeString(schedule, "h:mm A z", scheduleTimeZone)}</b>
      </li>
    );
  };

  return (
    <>
      <p className={styles.title}>
        <b>Almost done!</b>
      </p>
      <div className={styles.text} data-testid="tdf-confirmation-text">
        <b>{communicationTitle}</b> will be sent to:
        <br />
        <br />
        <ul>
          {getPeopleSection(selectedUserIds, selectedGroupIds, selectedTemplateIds, true)}
          {getDateTimeSection()}
        </ul>
        <br />
        {promptText}
      </div>
    </>
  );
};
